import { createClient } from "@supabase/supabase-js";
import axios from "axios";
import axiosRetry from "axios-retry";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Companyimg from "../../assets/img/image.png";
import { API, api_url, generateAuthHeader } from "../../util/util";

axiosRetry(axios, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
});

const supabaseUrl = process.env.REACT_APP_SUPABAE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASEKEY;
const supabase = createClient(supabaseUrl, supabaseKey);

function TrendingStartups() {
  const [islogin, setIsLoggedIn] = useState(false);
  const [trendingStartups, setTrendingStartups] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("login") === "true";

  const handleFetchTrendingData = async () => {
    const url = `${api_url}/${API.ENDPOINTS.trending}`;
    setLoading(true);
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: generateAuthHeader(),
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        setTrendingStartups(response.data);
      } else {
        console.error("Unexpected response");
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const checkUser = async () => {
      const { data } = await supabase.auth.getUser();
      if (data.user === null) {
        localStorage.removeItem("login");
        localStorage.removeItem("sb-hnfcpioavnlsyqepkgxo-auth-token");
        setIsLoggedIn(false);
        navigate("/");
      } else {
        handleFetchTrendingData();
      }
    };
    checkUser();
  }, [navigate]);

  const truncateText = (text, charLimit) => {
    return text.length > charLimit ? text.slice(0, charLimit) + "..." : text;
  };

  return (
    <section className="spad">
      <h3 className="h3-style">Popular Now</h3>
      {loading ? (
          <div className="text-center ">
          <div className="spinner-border  me-2" role="status">
              <span className="visually-hidden">Loading...</span>
          </div>
          <p>Data is coming soon</p>
      </div>
      ) : (
        <div className="row trending-startups">
          {trendingStartups.map((row, index) => (
            <div className="col-lg-3 col-md-4 col-sm-12 mb-4 p-1" key={index}>
              <div className="card h-100 card-main-trending shadow-sm">
                <div className="card-body card-body-border">
                  <a className="trending-a" href={`/details?query=${row.permalink}`}>
                    <img
                      src={row.logo ? row.logo : Companyimg} 
                      alt={row.company_name}
                      className="trending-image"
                    />
                  </a>
                  <a className="trending-a" href={`/details?query=${row.permalink}`}>
                    <h3 className="card-title">{row.company_name}</h3>
                  </a>
                  <a className="trending-a" href={`/details?query=${row.permalink}`}>
                    <p className="card-text">{truncateText(row.title, 100)}</p>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export default TrendingStartups;